import styled from "styled-components";
import { useAnimations, useCustomImage } from "../../hooks";
import { getClasses } from "../../utils";
import { useEffect, useRef, useState } from "react";

const Styled = styled.div`
  margin-top: -2em;
  display: flex;
  justify-content: center;
  align-self: center;
  .slide-out,
  .slide-in {
    position: absolute;
    background-size: contain;
    background-position: center calc(50% + 1em);
    background-repeat: no-repeat;
    height: 120%;
    width: 120%;
    max-width: 1600px;
    margin-top: -5em;
  }
  .slide-out {
    opacity: 1;
  }
  .slide-in {
    opacity: 0;
  }
  .slide-in.right {
    right: 100%;
  }
  .slide-in.left {
    left: 100%;
  }
  .slide-in.top {
    top: 100%;
  }
  .slide-in.bottom {
    bottom: 100%;
  }
` as any;

export type Direction = "left" | "right" | "top" | "bottom";
const getDirection = (i: number, j: number, last = 0): Direction => {
  if ((i === 0 && j === last) || (i === last && j === 0))
    return getDirection(j, i);

  console.log(i, j);
  return i > j ? "right" : "left";
};

const Slider: React.FC<{ index: number; direction: null | Direction; slides: string[] }> =
  ({ index, slides, direction }) => {
    const [animating, setAnimating] = useState(-1);
    const [i, setIndex] = useState(0);
    const slideOut = useRef(null);
    const slideIn = useRef(null);

    const outAnimaiton = {
      opacity: 0,
      duration: 0.6,
      ease: "power1.out",
      atStart: () => setAnimating(1),
    };
    const outAnimaitons = {
      left: { ...outAnimaiton, x: "-100%" },
      right: { ...outAnimaiton, x: "100%" },
      top: { ...outAnimaiton, y: "-100%" },
      bottom: { ...outAnimaiton, y: "100%" },
    };

    const inAnimation = {
      opacity: 1,
      display: "block",
      duration: 1.0,
      ease: "back.out(1)",
      atEnd: () => setAnimating(0),
    };

    const inAnimations = {
      left: { ...inAnimation, x: "-100%", main: "left" },
      right: { ...inAnimation, x: "100%", main: "right" },
      top: { ...inAnimation, y: "-100%", main: "top" },
      bottom: { ...inAnimation, y: "100%", main: "bottom" },
    };

    useEffect(() => {
      if (animating === 0) {
        playOutAnimation("reset");
        playInAnimation("reset");
        setIndex(index);
      }
    }, [animating]);

    useEffect(() => {
      if (index === i) return;
      const anim =
        direction === null
          ? getDirection(i, index, slides.length - 1)
          : direction;
      playOutAnimation(anim);
      playInAnimation(anim);
    }, [index]);

    const [animationClassOut, playOutAnimation] = useAnimations(
      Object.assign({}, outAnimaitons, {
        reset: { x: 0, y: 0, opacity: 1, duration: 0.01 },
      }),
      "slide-out",
      slideOut
    );
    const [animationClassN, playInAnimation] = useAnimations(
      Object.assign({}, inAnimations, {
        reset: { y: 0, x: 0, opacity: 0, display: "none", duration: 0.01 },
      }),
      "slide-in",
      slideIn
    );

    return (
      <Styled className="loading-screen-slides">
        <div
          ref={slideOut}
          className={getClasses({}, animationClassOut, "slide-out")}
          style={{ backgroundImage: `url("${useCustomImage(slides[i])}")` }}
        ></div>
        <div
          ref={slideIn}
          className={getClasses({}, animationClassN, "slide-in")}
          style={{
            backgroundImage: `url("${useCustomImage(slides[index])}")`,
          }}
        ></div>
      </Styled>
    );
  };

export default Slider;
